export enum Answer {
    Yes = 'Yes',
    No = 'No',
}
